import { useAppSelector } from './redux';

export const usePermission = () => {
  const permissions = useAppSelector((state) => state.auth.permissions);

  const can = (permission: string): boolean => {
    if (!permissions || permissions.length === 0) return false;
    return permissions.includes(permission);
  };

  const canAny = (perms: string[]): boolean => perms.some(can);

  const canAll = (perms: string[]): boolean => perms.every(can);

  return { can, canAny, canAll };
};
